import { TFunction } from 'i18next';

import { ColDef } from '~components/dataGrids/interfaces/colDef';
import { GridColTypeEnum } from '~components/dataGrids/interfaces/gridColTypeEnum';
import { BaseReference } from '~interfaces';
import i18n from '~lib/i18n';
import { defaultPlaceholder } from '~utils/stringUtils';

import {
	formatCronExpression,
	formatDateTimeCronExpression,
} from '../../../utils/cronExpressionFormatter';
import ScheduledActionTypeEnum from '../enums/scheduledActionTypeEnum';

interface ScheduledAction extends BaseReference {
	type: ScheduledActionTypeEnum;
	resourceGroupId?: string;
	description?: string;
	cronExpression?: string;
	start: Date;
	end?: Date;
	dateTime?: Date;
}

export default ScheduledAction;

export function formatScheduledActionCronExpression(
	scheduledAction: ScheduledAction | undefined,
	t: TFunction
): string {
	switch (scheduledAction?.type) {
		case ScheduledActionTypeEnum.Cron:
			return formatCronExpression(scheduledAction.cronExpression, i18n.resolvedLanguage ?? 'en');
		case ScheduledActionTypeEnum.DateTime:
			return formatDateTimeCronExpression(scheduledAction.dateTime, t);
		default:
			return defaultPlaceholder;
	}
}

export const scheduledActionGridCols: Record<string, ColDef<ScheduledAction>> = {
	cronExpression: {
		field: 'cronExpression',
		headerName: 'entities:schedule.labels.single',
		gridColType: GridColTypeEnum.TextBox,
		valueGetter: (value: ScheduledAction) => formatScheduledActionCronExpression(value, i18n.t),
		minWidth: 240,
		maxWidth: 420,
		defaultShown: true,
	},
};
